import styled from "styled-components";
import React from "react";

const ButtonOutlineTwo = (props) => {
  return (
    <ButtonTwoWrapperStyle>
      <div
        className="wrapper"
        disable={props.disabled}
        id={props.id}
        rounded={props.rounded}
        green={props.green}
        onClick={props.onClick ? props.onClick : undefined}
      >
        {props.title && <p>{props.title}</p>}
        {props.icon && <img src={props.icon} alt="button" />}
      </div>
    </ButtonTwoWrapperStyle>
  );
};

export default ButtonOutlineTwo;

const ButtonTwoWrapperStyle = styled.div`
  .wrapper {
    cursor: pointer;
    display: inline-block;
    border: solid 1px #3c4663;
    border-radius: 5px;
    padding: 4px 6px;
    background-color: #fff;
    transition-duration: 0.5s;
    cursor: pointer;
    &[disable="disabled"],
    &[disabled="disabled"] {
      background: #e5e8f0;
      border: 1px solid #e5e8f0;
      pointer-events: none;
    }
    &[rounded="rounded"] {
      border-radius: 100%;
    }
    &[green="green"] {
      border-color: #27ce0a;
      color: #27ce0a;
      p {
        color: #27ce0a;
        font-size: 16px;
        font-weight: 700;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
        }
      }
      &:hover,
      &.active {
        background-color: #27ce0a;
        color: #fff;
        p {
          color: fff;
        }
      }
    }
    &:hover,
    &.active {
      background: #3c4663;
      color: #fff;
      p {
        color: #fff;
      }
      img {
        filter: invert(0) sepia(0) saturate(1) hue-rotate(0deg) brightness(5);
      }
    }
    p {
      padding: 2px 6px;
      margin: 0;
      color: #3c4663;
      font-size: 12px;
      font-family: "robotomedium", sans-serif;
    }
  }
`;
